import { WebSearchDropdown } from '@terminal/components/chat/chat-input/chat-input-fields/web-search/WebSearchDropdown';
import { useTranslation } from 'react-i18next';

import styles from './WebSearchField.module.scss';

export const WebSearchField = () => {
  const { t } = useTranslation(['chat']);

  return (
    <div className={styles.fieldGroup}>
      <label className={styles.fieldLabel}>
        {t('chat:scheduledQuerySettings.webSearch')}
      </label>
      <WebSearchDropdown variant="select" />
    </div>
  );
};
